import { useWorkspaceQuery } from "@/hooks";
import { api } from "convex/_generated/api";
const DEFAULT_FLAGS = {
  isDemo: false,
} as const;

export function useFeatureFlags() {
  const flags = useWorkspaceQuery(
    api.workspace_feature_flags_queries.getForCurrentWorkspace,
  );

  return {
    flags: flags?.data ?? DEFAULT_FLAGS,
    isDemo: flags?.data?.isDemo ?? DEFAULT_FLAGS.isDemo,
    isLoading: flags === undefined,
  };
}
